import { LexicalEditor, $getSelection, $isRangeSelection } from "lexical";
import { useCallback } from "react";
import DropDown, { DropDownItem } from "../../ui/DropDown";
import { FONT_FAMILY_OPTIONS, FONT_SIZE_OPTIONS } from "./constants";
import { $patchStyleText, } from '@lexical/selection';
import { dropDownActiveClass } from "./ToolbarPluginUtils";

export default function ToolbarFontDropDown({
   editor,
   value,
   style,
   disabled = false,
}: {
   editor: LexicalEditor;
   value: string;
   style: string;
   disabled?: boolean;
}): JSX.Element {
   const handleClick = useCallback(
      (e: React.MouseEvent<HTMLElement>) => {
         const option = e.currentTarget.getAttribute("data-id")
         if (option) {
            editor.update(() => {
               const selection = $getSelection();
               if ($isRangeSelection(selection)) {
                  $patchStyleText(selection, {
                     [style]: option,
                  });
               }
            });
         }
      },
      [editor, style],
   );

   const buttonAriaLabel =
      style === 'font-family'
         ? 'Formatting options for font family'
         : 'Formatting options for font size';

   return (
      <DropDown
         disabled={disabled}
         buttonClassName={'toolbar-item ' + style}
         buttonLabel={value}
         buttonIconClassName={
            style === 'font-family' ? 'icon block-type font-family' : ''
         }
         buttonAriaLabel={buttonAriaLabel}>
         {(style === 'font-family' ? FONT_FAMILY_OPTIONS : FONT_SIZE_OPTIONS).map(
            ([option, text]) => (
               <DropDownItem
                  className={`item ${dropDownActiveClass(value === option)} ${style === 'font-size' ? 'fontsize-item' : ''}`}
                  dataId={option}
                  onClick={handleClick}
                  key={option}>
                  <span className="text">{text}</span>
               </DropDownItem>
            ),
         )}
      </DropDown>
   );
}